var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7234 7.44777C4.75179 7.44777 5.58547 6.61409 5.58547 5.5857C5.58547 4.55731 4.75179 3.72363 3.7234 3.72363C2.695 3.72363 1.86133 4.55731 1.86133 5.5857C1.86133 6.61409 2.695 7.44777 3.7234 7.44777Z",
    fill: "#7B86A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7234 13.0337C4.75179 13.0337 5.58547 12.2001 5.58547 11.1716C5.58547 10.1432 4.75179 9.30957 3.7234 9.30957C2.695 9.30957 1.86133 10.1432 1.86133 11.1716C1.86133 12.2001 2.695 13.0337 3.7234 13.0337Z",
    fill: "#7B86A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58547 16.7581C5.58547 17.7865 4.75179 18.6201 3.7234 18.6201C2.695 18.6201 1.86133 17.7865 1.86133 16.7581C1.86133 15.7296 2.695 14.896 3.7234 14.896C4.75179 14.896 5.58547 15.7296 5.58547 16.7581Z",
    fill: "#7B86A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5507 6.98207C20.0649 6.98207 20.4818 6.56523 20.4818 6.05103V5.12C20.4818 4.60581 20.0649 4.18896 19.5507 4.18896H8.3783C7.86411 4.18896 7.44727 4.60581 7.44727 5.12V6.05103C7.44727 6.56523 7.86411 6.98207 8.3783 6.98207H19.5507Z",
    fill: "#7B86A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4818 11.6375C20.4818 12.1517 20.0649 12.5685 19.5507 12.5685H8.3783C7.86411 12.5685 7.44727 12.1517 7.44727 11.6375V10.7064C7.44727 10.1922 7.86411 9.77539 8.3783 9.77539H19.5507C20.0649 9.77539 20.4818 10.1922 20.4818 10.7064V11.6375Z",
    fill: "#7B86A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5507 18.1544C20.0649 18.1544 20.4818 17.7376 20.4818 17.2234V16.2924C20.4818 15.7782 20.0649 15.3613 19.5507 15.3613H8.3783C7.86411 15.3613 7.44727 15.7782 7.44727 16.2924V17.2234C7.44727 17.7376 7.86411 18.1544 8.3783 18.1544H19.5507Z",
    fill: "#7B86A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/Actions.52c29ea4dc71680dd6d69cf9faa482b5.svg";
export { ForwardRef as ReactComponent };